/**
 * Created by neo on 19.12.20.
 */
import { makeAutoObservable } from 'mobx';
import { DietEquipment, createDietEquipment } from '../Equipment/DietEquipment';

export type RecipeEquipment = DietEquipment & {
  temperatureCelsius?: number;
};

export function createRecipeEquipment(json?: Partial<RecipeEquipment>): RecipeEquipment {
  const base = createDietEquipment(json);
  return makeAutoObservable({
    ...base,
    temperatureCelsius: json?.temperatureCelsius,
  });
}
